import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoggerService} from "../../../common/logger.service";
import {ICatalogView, ICategory, ITag} from "../catalog-models";
import {IAd} from "../../../landing/landing.models";
import {CatalogService} from "../catalog.service";
import * as _ from "lodash";
import {Constants} from "../../../constants";
import {Observable, Subscription} from "rxjs";
import {map} from "rxjs/operators";
import {BaseComponent} from "../../../base.component";
import {UserService} from "../../../common/user.service";
import {TranslateService} from "../../../translation/translate.service";
import {IShopUser} from "../../../session/customer-models";
import {LocaleUtil} from "../../../util/locale-util";

@Component({
    selector: 'catalog-hero',
    templateUrl: './catalog-hero.component.html',
    styleUrls: ['./catalog-hero.component.scss'],
    standalone: false
})
export class CatalogHeroComponent extends BaseComponent implements OnInit, OnDestroy{

    categoryAd: IAd;
    bannerDesktopUrl: string;
    bannerMobileUrl: string;
    viewTitle: string;
    viewShortDesc: string;
    adLink: string;
    viewSizeMobile = Constants.VIEWSIZE_MOBILE_MAX;
    filterViewSubscription: Subscription;

    constructor(
        private catalogService: CatalogService,
        private userService: UserService,
        private loggerService: LoggerService,
        private translateService: TranslateService
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.filterViewSubscription = this.catalogService.filterView$.subscribe((filterView) => {
            this.getCustomerData().then((user: IShopUser) => {
                this.getBannerItem(filterView, user);
            });
        });
    }

    ngOnDestroy(): void {
        if (this.filterViewSubscription) {
            this.filterViewSubscription.unsubscribe();
        }
    }

    getBannerItem(filterView: ICatalogView, user: IShopUser) {
        if (!!filterView.selectedCategory && filterView.selectedCategory.id > 0) {
            this.getCategoryAd(LocaleUtil.getTranslationLocale(user), filterView.selectedCategory.id).subscribe((response: IAd) => {
                if (response) {
                    this.populateAdView(response);
                } else {
                    this.populateBannerView(filterView.selectedCategory);
                }
            });
        } else if (!!filterView.selectedTag && filterView.selectedTag.id > 0) {
            this.populateBannerView(filterView.selectedTag);
        }
    }

    populateBannerView(bannerItem: ICategory | ITag) {
        this.translateService.translate(`${bannerItem.translationTag}.shortdesc`).then((translation: string) => this.viewShortDesc = translation);
        this.translateService.translate(`${bannerItem.translationTag}.title`).then((translation: string) => this.viewTitle = translation);
        _.forEach(bannerItem.images, (image: any) => {
            if (image.imageType) {
                if (image.imageType == Constants.BANNER_DESKTOP_IMAGE_TYPE) {
                    this.bannerDesktopUrl = image.imagePath;
                } else if (image.imageType == Constants.BANNER_MOBILE_IMAGE_TYPE) {
                    this.bannerMobileUrl = image.imagePath;
                }
            }
        });
    }

    populateAdView(bannerAdItem: IAd) {
        this.viewShortDesc = bannerAdItem.imageDescription;
        this.viewTitle = bannerAdItem.imageTitle;
        this.adLink = bannerAdItem.adLink;
        _.forEach(bannerAdItem.images, (image: any) => {
            if (image.imageType) {
                if (image.imageType == Constants.IMAGE_TYPE_DESKTOP) {
                    this.bannerDesktopUrl = image.imagePath;
                } else if (image.imageType == Constants.IMAGE_TYPE_MOBILE) {
                    this.bannerMobileUrl = image.imagePath;
                }
            }
        });
    }

    getCategoryAd(usanaLocale: string, CategoryId): Observable<any> {
        return this.catalogService.getCategoryAd(usanaLocale, Constants.AD_CATEGORY_BANNER, CategoryId).pipe(
            map((response: IAd[]) => {
                this.categoryAd = response[0];
                this.log.debug("getCategoryAd", "Ad for Category Banner space", response);
                return this.categoryAd;
            })
        );
    }
}
